var map = {
	"./activity.png": "7fc7",
	"./customer.png": "8878",
	"./expense.jpg": "b54f",
	"./pos.jpg": "0de1",
	"./pos.png": "18f3",
	"./product.png": "7ab4",
	"./stock.jpg": "54e0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bf13";